var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"rating-header"},[_c('v-container',{staticClass:"rating-header__logo mt-4"},[_c('v-img',{staticClass:"logo d-flex align-start",attrs:{"src":"/img/logo.gif","aspect-ratio":_vm.ratio,"contain":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }